import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private platformId = inject(PLATFORM_ID);

  private get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  post(key: string, value: string): void {
    if (!this.isBrowser) return;
    sessionStorage.setItem(key, value);
  }

  get(key: string): string | null {
    if (!this.isBrowser) return null;
    return sessionStorage.getItem(key);
  }

  remove(key: string): void {
    if (!this.isBrowser) return;
    sessionStorage.removeItem(key);
  }

  clear(): void {
    if (!this.isBrowser) return;
    sessionStorage.clear();
  }

  // ────────── Typed convenience helpers ──────────

  get token(): string | null {
    return this.get('user.token');
  }

  get sessionId(): string | null {
    return this.get('user.session');
  }

  getSession(): string | null {
    return this.sessionId;
  }

  get userId(): string | null {
    return this.get('user.id');
  }

  get userName(): string | null {
    return this.get('user.name');
  }

  get baseLocationId(): string | null {
    return this.get('user.baselocationid');
  }

  get baseLocation(): string | null {
    return this.get('user.baselocation');
  }

  get moduleId(): string | null {
    return this.get('session.module_id');
  }

  get pricingClass(): string | null {
    return this.get('user.pricingclass');
  }

  get sessionCount(): string | null {
    return this.get('user.sessionCount');
  }

  setTokenDetails(token: string, sessionId: string): void {
    this.post('user.token', token);
    this.post('user.session', sessionId);
  }

  setUserDetails(user: {
    id: string | number;
    name: string;
    token: string;
    session_id: string;
    baselocationId?: string | number;
    baselocation?: string;
    pricing_classification_id?: string;
  }): void {
    this.post('user', JSON.stringify(user));
    this.post('user.id', String(user.id));
    this.post('user.name', String(user.name));
    if (user.baselocationId !== undefined) {
      this.post('user.baselocationid', String(user.baselocationId));
    }
    if (user.baselocation !== undefined) {
      this.post('user.baselocation', String(user.baselocation));
    }
  }
}